import { Button, Popover } from "@mui/material";
import Box from "@mui/material/Box";
import theme from "@root/styles/theme";
import { useState } from "react";
import { FaPalette } from "react-icons/fa6";
import { v4 as uuidv4 } from "uuid";

import { ColorName, Colors } from "../../SVBubble/constants";
import { getCheckBoxImage } from "../../useSVEditorStyles";

type Props = {
  handleSelectColor: (color: ColorName) => void;
  selectedColor?: ColorName;
};

export const ColorButtonSection = ({
  handleSelectColor,
  selectedColor,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? `color-select-popper-${uuidv4()}` : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button onClick={handleClick}>
        <FaPalette />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            border: "none",
            padding: theme.spacing(1),
            bgcolor: "background.paper",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 1,
            }}
          >
            {Object.keys(Colors).map((color) => {
              return (
                <Button
                  variant="text"
                  key={color}
                  onClick={() => {
                    handleSelectColor(color as ColorName);
                    setAnchorEl(null);
                  }}
                  sx={{
                    border: "1px solid #ccc",
                    position: "relative",
                    bgcolor: color,
                    width: "32px !important",
                    height: "32px !important",
                    padding: 0,
                    minWidth: 0,
                    hover: {
                      bgcolor: color,
                    },
                    backgroundImage:
                      selectedColor === color
                        ? getCheckBoxImage("rgb(71, 81, 73)", 32, 32)
                        : undefined,
                  }}
                />
              );
            })}
          </Box>
        </Box>
      </Popover>
    </>
  );
};
